import React from 'react';
import styled from 'styled-components';

const PDFDownloadLink = ({ PDFError, PDFUrl }) => {
  if (PDFError) {
    return (
      <PDFDownloadBlock>
        Во время генерации произошла ошибка.. Пожалуйста попробуйте еще раз
      </PDFDownloadBlock>
    );
  }

  if (PDFUrl) {
    return (
      <PDFDownloadBlock>
        <a href={PDFUrl}>Нажмите сюда для начала скачивания ПДФ с меню</a>
      </PDFDownloadBlock>
    );
  }

  return null;
};

export default PDFDownloadLink;

const PDFDownloadBlock = styled.div`
  margin: 0 auto;
  width: 300px;
  height: 50px;
  text-align: center;
`;



// WEBPACK FOOTER //
// ./src/Components/MenuGenerator/DetailsForGenerateBlock/PDFDownloadLink.jsx